/** 検索数(初期表示100件) */
export const SELECT_INIT_SIZE = 100;

/** 検索数(最大表示500件) */
export const SELECT_MAX_SIZE = 500;

/**
 * 顧客・車両情報の候補のグリッド列の設定
 */
export const ColumnDefs = [
    {
      headerName: '受付日',
      field: 'dispReceptionDate',
      minWidth: 140,
    },
    {
      headerName: '受付サービス',
      field: 'dispItemServiceName',
      minWidth: 140,
    },
    {
      headerName: '見積希望日時',
      field: 'dispVisitStartDateTime',
      minWidth: 140,
    },
    {
      headerName: '入庫日時',
      field: 'dispItemServiceOfferStartDateTime',
      minWidth: 140,
    },
    {
      headerName: '更新日時',
      field: 'dispUpdateDateTime',
      minWidth: 140,
    }
  ];



// WEBPACK FOOTER //
// ./src/app/feature/web-reserve-reception-link/web-reserve-reception-link.define.ts